import React from "react";
import Footer from "../components/Footer";
import "../App.css"; // Make sure you have styles

const newsArticles = [
  {
    id: 6,
    title: "Successful CAT Main Engine Troubleshooting & Technical Inspection – MV Shxxxxx Oxxxxx.",
    date: "May 2026",
    scope: "Internal Policy Reform",
    summary: ["Port Name - GALLE, SRI LANKA",
      "Engine Model - CAT 3516B-HD",
      "Proud to share another successful technical troubleshooting and repair operation carried out by Blue Waves Ship Management Pvt Ltd onboard MV Shxxxxxx Oxxxxxxx.",
      "During vessel operations, abnormal smoke emission was observed from the main engine crankcase breather. Our technical team immediately addressed the issue and conducted a detailed onboard inspection and troubleshooting to identify the root cause.",
      "The work carried out included:",
      "✔️ Removal of top covers for internal inspection",
      "✔️ Detailed visual inspection of engine internal components",
      "✔️ Inspection of the camshaft compartment, where heavy smoke presence was identified",
      "✔️ Sequential fuel cut-off testing on each cylinder unit during engine operation for fault identification",
      "✔️ Technical assessment and troubleshooting of suspected low compression condition",
      "Further inspection was carried out by removing the suspected unit cylinder head, during which damaged piston rings and liner scoring were identified. The defective liner and piston assembly were subsequently replaced with new components, and the Blue Waves Ship Management technical team completed the rectification work.",
      "This operation highlights the strong technical expertise, rapid response capability, and professional repair approach provided by Blue Waves Ship Management in supporting vessel operators and minimizing operational downtime.",
      "We remain committed to delivering reliable marine engineering solutions with safety, efficiency, and professionalism.",],
    image: [
      "/images/cat1.webp",
      "/images/cat2.webp",
      "/images/cat3.webp"
    ],

    link: "https://www.linkedin.com/posts/blue-waves-38898536b_shiprepair-steelrepairs-marineservices-activity-7421441749425860608-GDrw?utm_source=share&utm_medium=member_desktop&rcm=ACoAACMFQTIBGuhaRQmaCzUCChFCexz7NkCSNn8",
  },
  {
    id: 5,
    title: "Ship Steel Repairs By BWSM",
    date: "October 10, 2025",
    summary: "BWSM successfully completed complex steel renewal and structural repairs, ensuring the vessel's integrity and compliance with international safety standards.",
    image: [
      "/images/steal.webp",
      "/images/walding.webp",
      "/images/ship-complete.webp",
    ],
    link: "https://www.linkedin.com/posts/blue-waves-38898536b_shiprepair-steelrepairs-marineservices-activity-7421441749425860608-GDrw?utm_source=share&utm_medium=member_desktop&rcm=ACoAACMFQTIBGuhaRQmaCzUCChFCexz7NkCSNn8",
  },
  {
    id: 4,
    title: "Providing Marine Security",
    date: "October 10, 2025",
    summary:
      "Ensuring the safety of our vessels and crew with advanced security protocols.",
    image: "/images/marinesecurity.webp",
    link: "https://maritimeducation.com/maritime-security-safeguarding-global-trade-and-maritime-operations/",
  },
  {
    id: 3,
    title: "Marinelink Global News",
    date: "June 10, 2025",
    // summary: 'A step forward toward reducing carbon emissions across our managed fleet.',
    image: "/images/news3.webp",
    link: "https://www.marinelink.com/",
  },
  {
    id: 2,
    title: "Marine Insite Stories",
    date: "June 22, 2025",
    // summary: 'We’re proud to announce our certification in environmental management systems.',
    image: "/images/news2.webp",
    link: "https://www.marineinsight.com/web-stories/",
  },
  {
    id: 1,
    title: "IMO Whats New",
    date: "July 1, 2025",
    // summary: 'Our latest digital tool enhances vessel monitoring and crew scheduling with real-time insights.',
    image: "/images/news1.webp",
    link: "https://www.imo.org/en/mediacentre/pages/default.aspx",
  },
];

const News = () => {
  return (
    <div>
      {/* Cover Section */}
      <div className="news-cover">
        <img
          src="/images/news-banner.webp"
          alt="News Banner"
          className="news-cover-image"
        />
        <div className="news-cover-text">
          <h1>Company News</h1>
          <p>
            Latest updates, industry insights, and achievements at Blue Wave
          </p>
        </div>
      </div>

      {/* News Grid */}
      <section className="news-section container">
        <h2 className="news-heading">Latest Articles</h2>
        <div className="news-grid">
          {newsArticles.map((article) => (
            <a
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              className="news-card"
              key={article.id}
            >
              <div
                className={
                  Array.isArray(article.image)
                    ? "news-image-gallery"
                    : "news-image-single"
                }
              >
                {Array.isArray(article.image) ? (
                  article.image.map((imgSrc, index) => (
                    <img
                      key={index}
                      src={imgSrc}
                      alt={`${article.title} ${index}`}
                      className="news-card-image"
                      loading="lazy"
                    />
                  ))
                ) : (
                  <img
                    src={article.image}
                    alt={article.title}
                    className="news-card-image"
                    loading="lazy"
                  />
                )}
              </div>

              <div className="news-card-content">
                <h3>{article.title}</h3>
                <p className="news-date">{article.date}</p>
                {Array.isArray(article.summary) ? (
                  <div className="news-summary">
                    {article.summary.slice(0, 3).map((item, idx) => (
                      <p key={idx} style={{ margin: "0.25rem 0" }}>{item}</p>
                    ))}
                    {article.summary.length > 3 && <p style={{ fontStyle: "italic", marginTop: "0.5rem", color: "#f59e0b" }}>Read full report on LinkedIn →</p>}
                  </div>
                ) : (
                  <p className="news-summary">{article.summary}</p>
                )}
              </div>
            </a>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default News;
